import { Link } from "@chakra-ui/react"

export const ButtonSecondary = ({ href,isExternal,children ,...rest }) =>{
    return(
        <Link
            w="110px"
            h="50px"
            bg="blue.400"
            padding="5px"
            _hover={{
                bg:"blue.300"
            }}
            borderRadius="none"
            href={href}
            isExternal={isExternal}
            textAlign="center"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight="bold"
        >{ children }</Link>
    )
}